import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Box, CircularProgress, Divider } from '@mui/material';
import { PopOver } from 'common/components/PopOver';

type CsvReportExportPopupLoaderProps = {
	title: string;
    open: boolean;
};

export const CsvReportExportPopupLoader = ({
    open,
    title
}: CsvReportExportPopupLoaderProps) => {

    return (
        <PopOver
            title={title}
            open={open}
            showCloseIcon={false}
        >
            <Divider sx={{ borderColor: 'transparent' }}/>
            <Box sx={{
                backgroundColor: 'primary.accent',
                height: '3rem',
                width: '3rem',
                borderRadius: '100%',
                position: 'absolute',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}>
                <FileDownloadOutlinedIcon fontSize='large'
                    sx={{
                        color: 'common.white',
                        marginTop: '7px',
                        marginLeft: '6px'
                    }}
                />
            </Box>
            <Divider sx={{ borderColor: 'transparent' }}/>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '10px'
            }}>
                <CircularProgress />
            </div>
        </PopOver>
    );

};
